import { Box } from '@mui/material'
import { PRIMARIO } from '../tema'

export function Icona({ d, dimensione = 20 }: { d: string; dimensione?: number }) {
  return (
    <svg width={dimensione} height={dimensione} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  )
}

// Stesso segno del sito (apps/site/src/components/Icona.astro, «scudo»).
const SCUDO = 'M12 3.5 5 6v5.5c0 4.2 2.9 7.4 7 8.5 4.1-1.1 7-4.3 7-8.5V6l-7-2.5Zm-2.8 8.2 2 2 4.6-4.6'

export function Marchio({ chiaro = false }: { chiaro?: boolean }) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, fontWeight: 700, fontSize: '1.1875rem',
      color: chiaro ? '#fff' : 'text.primary' }}>
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 32, height: 32, borderRadius: '8px', color: chiaro ? PRIMARIO : '#fff', bgcolor: chiaro ? '#fff' : PRIMARIO }}>
        <Icona d={SCUDO} />
      </Box>
      PraticheEnergia
    </Box>
  )
}
